import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { platformAdminApi } from "../../api/platformAdminApi";
var RATES_KEY = ["admin-platform-rates"];
var BREAKDOWN_KEY = ["admin-fee-breakdown"];
var WITHDRAWALS_KEY = ["admin-platform-withdrawals"];
export var usePlatformRates = function () {
    return useQuery({
        queryKey: RATES_KEY,
        queryFn: platformAdminApi.getRates,
    });
};
export var useFeeBreakdown = function () {
    return useQuery({
        queryKey: BREAKDOWN_KEY,
        queryFn: platformAdminApi.getBreakdown,
        staleTime: 30000,
    });
};
var useRateMutation = function (mutationFn) {
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: mutationFn,
        onSuccess: function (data) { return queryClient.setQueryData(RATES_KEY, data); },
    });
};
export var useUpdateNftFee = function () { return useRateMutation(platformAdminApi.setNftFee); };
export var useUpdateSwapFee = function () { return useRateMutation(platformAdminApi.setSwapFee); };
export var useUpdateWithdrawalFee = function () {
    return useRateMutation(platformAdminApi.setWithdrawalFee);
};
// Вывод средств: после успеха инвалидируем breakdown (обновится available) и
// историю выводов (появятся новые записи).
export var useWithdrawFees = function () {
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: platformAdminApi.withdrawFees,
        onSuccess: function () {
            queryClient.invalidateQueries({ queryKey: BREAKDOWN_KEY });
            queryClient.invalidateQueries({ queryKey: WITHDRAWALS_KEY });
        },
    });
};
export var useWithdrawalHistory = function () {
    return useQuery({
        queryKey: WITHDRAWALS_KEY,
        queryFn: platformAdminApi.getWithdrawals,
        staleTime: 15000,
    });
};
